import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Http} from '@angular/http';
import {DictionaryObject} from '../../../../../../../common/api';

@Injectable()
export class CardStatesService {
    constructor(private http: Http) {
    }

    getRegisteredClientCardStates(): Observable<DictionaryObject[]> {
        return this.http.get('/api/backoffice/cards/registered-client-card-states')
            .map(responce => responce.json())
            .map(responce => responce.statuses);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/card-states-service.ts